import { render, staticRenderFns } from "./SetUserGroupCard.vue?vue&type=template&id=21e2c6d4&"
import script from "./SetUserGroupCard.vue?vue&type=script&lang=js&"
export * from "./SetUserGroupCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports